<div class="action-container">
  <app-action-field class="action-field"
                    [isRepeatable]="true"
                    [isDeletable]="isDeletable"
                    (addSomething)="createSomething()"
                    (deleteSomething)="removeSomething()">
  </app-action-field>
</div>
<div id="accordionGroup" class="accordion">
  <h3 class="accordion-container">
    <button
      type="button"
      [attr.aria-expanded]="isExpanded$ | async"
      class="accordion-trigger"
      [attr.aria-controls]="'sect-'+getDuplicableElementId()"
      [attr.id]="getDuplicableElementId()"
      (click)="toggleAccordion(actualIndex)">
      <span class="accordion-title" [attr.id]="prefixId+'|'+getDuplicableElementId()">
        {{ getAccordionTitle() }}
        <span class="accordion-icon"></span>
      </span>
    </button>
    <mat-icon *ngIf="infoBulle" matTooltip="Informations" (click)="getEvent($event)" aria-hidden="false"
              class="info-icon">
      info
    </mat-icon>
  </h3>
  <div [attr.id]="'sect-'+getDuplicableElementId()"
       role="region"
       [attr.aria-labelledby]="getDuplicableElementId()"
       class="accordion-panel content"
      *ngIf="isExpanded$ | async">
    <fieldset>
      <legend></legend>
      <ng-content></ng-content>
    </fieldset>
  </div>
</div>

